// extracted by mini-css-extract-plugin
module.exports = {"table":"theme_table__+1b0k","sortable":"theme_sortable__NJCyw","active":"theme_active__4GtRt","sortIcon":"theme_sortIcon__PyRUO","zebra":"theme_zebra__ekD0c"};